import { Injectable } from '@angular/core';
import { AngularFirestore, QueryFn } from '@angular/fire/compat/firestore';
import { Timestamp } from 'firebase/firestore';
import { firstValueFrom } from 'rxjs';

import { Godson } from '../domain/godson/godson';

export interface GodsonSchema {
  dietitianId: string;
  dietitianFullName: string;
  createdAt: Timestamp;
  gain: number;
  stripeBalanceId: string;
}

@Injectable()
export class GodsonRepository {
  constructor(private firestore: AngularFirestore) {
    // nada
  }

  private collection(dietitianId: string, queryFn?: QueryFn) {
    return this.firestore
      .collection('dietitians')
      .doc(dietitianId)
      .collection<GodsonSchema>('godsons', queryFn);
  }

  async findAll(dietitianId: string): Promise<Godson[]> {
    try {
      const snap = await firstValueFrom(this.collection(dietitianId).get());
      return snap.docs.map((doc) => this.fromSchema(doc.data()));
    } catch (e) {
      console.error('❌ GodsonRepo.findAll', e);
      throw e;
    }
  }

  private fromSchema(schema: GodsonSchema) {
    return Godson.create({
      createdAt: schema.createdAt.toDate(),
      gain: schema.gain,
      stripeBalanceId: schema.stripeBalanceId,
      dietitianId: schema.dietitianId,
      dietitianFullName: schema.dietitianFullName ?? undefined,
    });
  }
}
